import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c61daf7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-box" }

import {ref, watch} from 'vue';
import _ from 'lodash';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {NumberRangeSearch} from "@/components/business/crud/interface/SearchType";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberRangeSearch',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const minValue = ref<number>();
const maxValue = ref<number>();

watch(() => data.value[props.propName], () => {
  if (typeof data.value[props.propName]?.$gte === "number") {
    minValue.value = data.value[props.propName]?.$gte;
  } else {
    minValue.value = undefined;
  }
  if (typeof data.value[props.propName]?.$lte === "number") {
    maxValue.value = data.value[props.propName]?.$lte;
  } else {
    maxValue.value = undefined;
  }
})

watch(minValue, () => {
  if (minValue.value !== undefined) {
    _.set(data.value, [props.propName, "$gte"], getValueByType(minValue.value))
  } else if (data.value[props.propName]) {
    _.set(data.value, [props.propName, "$gte"], undefined)
  }
}, {immediate: true, deep: true});

watch(maxValue, () => {
  if (maxValue.value !== undefined) {
    _.set(data.value, [props.propName, "$lte"], getValueByType(maxValue.value))
  } else if (data.value[props.propName]) {
    _.set(data.value, [props.propName, "$lte"], undefined)
  }
}, {immediate: true, deep: true});

function getValueByType(value: string | number) {
  return props.widget.type === "string" ? value.toString() : Number(value);
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_input_number, {
      class: "min",
      value: minValue.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((minValue).value = $event)),
      disabled: _ctx.info.status === 'show',
      placeholder: _ctx.info.title + '最小值',
      precision: _ctx.widget.scale
    }, null, 8, ["value", "disabled", "placeholder", "precision"]),
    _createVNode(_component_a_input_number, {
      class: "max",
      value: maxValue.value,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((maxValue).value = $event)),
      disabled: _ctx.info.status === 'show',
      placeholder: _ctx.info.title + '最大值',
      precision: _ctx.widget.scale
    }, null, 8, ["value", "disabled", "placeholder", "precision"])
  ]))
}
}

})